import type { Signal } from '@/api/signals'

// "Needs you" matches the Signals inbox — set-aside and acted-on signals never lead Home.
export const needsYou = (s: Signal): boolean => s.status === 'fresh' || s.status === 'seen'

// The Action Brief's candidates: the top five signals that still need you, by importance.
const ORDER = { High: 0, Medium: 1, Low: 2 } as Record<string, number>

export function briefSignals(signals: Signal[]): Signal[] {
  return signals
    .filter(needsYou)
    .sort((a, b) => (ORDER[a.importance] ?? 3) - (ORDER[b.importance] ?? 3))
    .slice(0, 5)
}

// Home's "Latest signals": newest first as the API returns them, only what still needs you.
export function latestSignals(signals: Signal[], n: number): Signal[] {
  return signals.filter(needsYou).slice(0, n)
}
